import {
    GET_ERROR_LISTGROUPS,
    GET_ERROR_LISTROLES,
    GET_ERROR_LISTUSERS,
    GET_ERROR_USERKEYCLOAKINFO,
    GET_LISTGROUPS,
    GET_LISTROLES,
    GET_LISTUSERS,
    GET_USERKEYCLOAKINFO,
    LOADING_ASSIGNGRUPOS,
    LOADING_ASSIGNROLES,
    LOADING_CREATEUSER,
    LOADING_LISTGROUPS,
    LOADING_LISTROLES,
    LOADING_LISTUSERS,
    LOADING_UPDATEPASSWORD, LOADING_UPDATEPASSWORD_ADMIN,
    LOADING_UPDATE_USER,
    LOADING_USERKEYCLOAKINFO,
    POST_ASSIGNGRUPOS,
    POST_ASSIGNROLES,
    POST_CREATEUSER,
    POST_ERROR_ASSIGNGRUPOS,
    POST_ERROR_ASSIGNROLES,
    POST_ERROR_CREATEUSER,
    POST_ERROR_UPDATEPASSWORD, POST_ERROR_UPDATEPASSWORD_ADMIN,
    POST_ERROR_UPDATE_USER,
    POST_UPDATEPASSWORD, POST_UPDATEPASSWORD_ADMIN,
    POST_UPDATE_USER,
    RESET_PASSWORD_ADMIN,
    RESET_STATE_LISTUSERS, POST_SYNCHRONIZED_KEYCLOAK, POST_ERROR_SYNCHRONIZED_KEYCLOAK, LOADING_SYNCHRONIZED_KEYCLOAK,
    GET_UNSYNC_USERS_SUCCESS, GET_UNSYNC_USERS_REQUEST, GET_UNSYNC_USERS_ERROR, ACTIVATE_USER_REQUEST,
    ACTIVATE_USER_SUCCESS, ACTIVATE_USER_ERROR, ACTIVATE_MULTIPLE_USERS_REQUEST, ACTIVATE_MULTIPLE_USERS_SUCCESS,
    ACTIVATE_MULTIPLE_USERS_ERROR
} from "../../actionsType/admin/adminActionType"


const INITIAL_STATE = {
    loading_listUsers: false,
    error_listUsers: null,
    success_listUsers: null,
    loading_createUser: false,
    error_createUser: null,
    success_createUser: null,
    loading_listRoles: false,
    error_listRoles: null,
    success_listRoles: null,
    loading_userKeycloakInfo: false,
    error_userKeycloakInfo: null,
    success_userKeycloakInfo: null,
    loading_assignRoles: false,
    error_assignRoles: null,
    success_assignRoles: null,
    loading_updatePassword: false,
    error_updatePassword: null,
    success_updatePassword: null,
    loading_update_user: false,
    error_update_user: null,
    success_update_user: null,
    loading_grupos: false,
    error_grupos: null,
    success_grupos: null,
    loading_listGroups: false,
    error_listGroups: null,
    success_listGroups: null,
    loadingUserPasswordAdmin: false,
    errorUserPasswordAdmin: null,
    successUserPasswordAdmin: false,
    loadingSinchronized: false,
    errorSinchronized: null,
    successSinchronized: false,
    loadingUnsyncUser: false,
    errorUnsyncUser: null,
    successUnsyncUser: false,
    loadingActivateUser: false,
    errorActivateUser: null,
    successActivateUser: false,
    loadingActivateMultipleUsers: false,
    errorActivateMultipleUsers: null,
    successActivateMultipleUsers: false
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RESET_STATE_LISTUSERS:
            return {
                ...state,
                loading_listUsers: false,
                error_listUsers: null,
                loading_createUser: false,
                error_createUser: null,
                success_createUser: null,
                loading_listRoles: false,
                error_listRoles: null,
                loading_userKeycloakInfo: false,
                error_userKeycloakInfo: null,
                loading_assignRoles: false,
                error_assignRoles: null,
                success_assignRoles: null,
                loading_updatePassword: false,
                error_updatePassword: null,
                success_updatePassword: null,
                loading_update_user: false,
                error_update_user: null,
                success_update_user: null,
                loading_grupos: false,
                error_grupos: null,
                success_grupos: null,
                loading_listGroups: false,
                error_listGroups: null,
                loadingSinchronized: false,
                errorSinchronized: null,
                successSinchronized: null,
                loadingUnsyncUser: false,
                successUnsyncUser: null,
                errorUnsyncUser: null,
                loadingActivateUser: false,
                errorActivateUser: null,
                successActivateUser: null,
                loadingActivateMultipleUsers: false,
                errorActivateMultipleUsers: null,
                successActivateMultipleUsers: null
            }
        case GET_LISTUSERS:
            return {
                ...state,
                loading_listUsers: false,
                error_listUsers: null,
                success_listUsers: action.payload
            }
        case LOADING_LISTUSERS:
            return {
                ...state,
                loading_listUsers: true,
                error_listUsers: null,
                success_listUsers: null
            }
        case GET_ERROR_LISTUSERS:
            return {
                ...state,
                error_listUsers: action.payload,
                loading_listUsers: false
            }

        case POST_CREATEUSER:
            return {
                ...state,
                loading_createUser: false,
                error_createUser: null,
                success_createUser: action.payload
            }
        case LOADING_CREATEUSER:
            return {
                ...state,
                loading_createUser: true,
                error_createUser: null,
                success_createUser: null
            }
        case POST_ERROR_CREATEUSER:
            return {
                ...state,
                error_createUser: action.payload,
                loading_createUser: false
            }

        case GET_LISTROLES:
            return {
                ...state,
                loading_listRoles: false,
                error_listRoles: null,
                success_listRoles: action.payload
            }
        case LOADING_LISTROLES:
            return {
                ...state,
                loading_listRoles: true,
                error_listRoles: null,
                success_listRoles: null
            }
        case GET_ERROR_LISTROLES:
            return {
                ...state,
                error_listRoles: action.payload,
                loading_listRoles: false
            }

        case GET_USERKEYCLOAKINFO:
            return {
                ...state,
                loading_userKeycloakInfo: false,
                error_userKeycloakInfo: null,
                success_userKeycloakInfo: action.payload
            }
        case LOADING_USERKEYCLOAKINFO:
            return {
                ...state,
                loading_userKeycloakInfo: true,
                error_userKeycloakInfo: null,
                success_userKeycloakInfo: null
            }
        case GET_ERROR_USERKEYCLOAKINFO:
            return {
                ...state,
                error_userKeycloakInfo: action.payload,
                loading_userKeycloakInfo: false
            }

        case POST_ASSIGNROLES:
            return {
                ...state,
                loading_assignRoles: false,
                error_assignRoles: null,
                success_assignRoles: action.payload
            }
        case LOADING_ASSIGNROLES:
            return {
                ...state,
                loading_assignRoles: true,
                error_assignRoles: null,
                success_assignRoles: null
            }
        case POST_ERROR_ASSIGNROLES:
            return {
                ...state,
                error_assignRoles: action.payload,
                loading_assignRoles: false
            }

        case POST_UPDATEPASSWORD:
            return {
                ...state,
                loading_updatePassword: false,
                error_updatePassword: null,
                success_updatePassword: action.payload
            }
        case LOADING_UPDATEPASSWORD:
            return {
                ...state,
                loading_updatePassword: true,
                error_updatePassword: null,
                success_updatePassword: null
            }
        case POST_ERROR_UPDATEPASSWORD:
            return {
                ...state,
                error_updatePassword: action.payload,
                loading_updatePassword: false
            }

        case POST_UPDATE_USER:
            return {
                ...state,
                loading_update_user: false,
                error_update_user: null,
                success_update_user: action.payload
            }
        case LOADING_UPDATE_USER:
            return {
                ...state,
                loading_update_user: true,
                error_update_user: null,
                success_update_user: null
            }
        case POST_ERROR_UPDATE_USER:
            return {
                ...state,
                error_update_user: action.payload,
                loading_update_user: false
            }

        case POST_ASSIGNGRUPOS:
            return {
                ...state,
                loading_grupos: false,
                error_grupos: null,
                success_grupos: action.payload
            }
        case LOADING_ASSIGNGRUPOS:
            return {
                ...state,
                loading_grupos: true,
                error_grupos: null,
                success_grupos: null
            }
        case POST_ERROR_ASSIGNGRUPOS:
            return {
                ...state,
                error_grupos: action.payload,
                loading_grupos: false
            }

        case GET_LISTGROUPS:
            return {
                ...state,
                loading_listGroups: false,
                error_listGroups: null,
                success_listGroups: action.payload
            }
        case LOADING_LISTGROUPS:
            return {
                ...state,
                loading_listGroups: true,
                error_listGroups: null,
                success_listGroups: null
            }
        case GET_ERROR_LISTGROUPS:
            return {
                ...state,
                error_listGroups: action.payload,
                loading_listGroups: false
            }
        case RESET_PASSWORD_ADMIN:
            return {
                ...state,
                loadingUserPasswordAdmin: false,
                errorUserPasswordAdmin: null,
                successUserPasswordAdmin: false
            }
        case POST_UPDATEPASSWORD_ADMIN:
            return {
                ...state,
                loadingUserPasswordAdmin: false,
                successUserPasswordAdmin: true
            }
        case LOADING_UPDATEPASSWORD_ADMIN:
            return {
                ...state,
                loadingUserPasswordAdmin: true,
                errorUserPasswordAdmin: null,
                successUserPasswordAdmin: false
            }
        case POST_ERROR_UPDATEPASSWORD_ADMIN:
            return {
                ...state,
                errorUserPasswordAdmin: action.payload,
                loadingUserPasswordAdmin: false
            }
        case POST_SYNCHRONIZED_KEYCLOAK:
            return {
                ...state,
                loadingSinchronized: false,
                successSinchronized: true
            }
        case LOADING_SYNCHRONIZED_KEYCLOAK:
            return {
                ...state,
                loadingSinchronized: true,
                errorSinchronized: null,
                successSinchronized: false
            }
        case POST_ERROR_SYNCHRONIZED_KEYCLOAK:
            return {
                ...state,
                errorSinchronized: action.payload,
                loadingSinchronized: false
            }
        case GET_UNSYNC_USERS_SUCCESS: {
            const payload = action.payload

            if (!payload || !Array.isArray(payload)) {
                return {
                    ...state,
                    loadingUnsyncUser: false,
                    successUnsyncUser: []
                }
            }

            return {
                ...state,
                loadingUnsyncUser: false,
                successUnsyncUser: payload
            }
        }
        case GET_UNSYNC_USERS_REQUEST:
            return {
                ...state,
                loadingUnsyncUser: true,
                errorUnsyncUser: null,
                successUnsyncUser: false
            }
        case GET_UNSYNC_USERS_ERROR:
            return {
                ...state,
                errorUnsyncUser: action.payload,
                loadingUnsyncUser: false
            }
        case ACTIVATE_USER_SUCCESS:
            return {
                ...state,
                loadingActivateUser: false,
                successActivateUser: action.payload
            }
        case ACTIVATE_USER_REQUEST:
            return {
                ...state,
                loadingActivateUser: true,
                errorActivateUser: null,
                successActivateUser: false
            }
        case ACTIVATE_USER_ERROR:
            return {
                ...state,
                errorActivateUser: action.payload,
                loadingActivateUser: false
            }
        case ACTIVATE_MULTIPLE_USERS_SUCCESS:
            return {
                ...state,
                loadingActivateMultipleUsers: false,
                successActivateMultipleUsers: action.payload
            }
        case ACTIVATE_MULTIPLE_USERS_REQUEST:
            return {
                ...state,
                loadingActivateMultipleUsers: true,
                errorActivateMultipleUsers: null,
                successActivateMultipleUsers: false
            }
        case ACTIVATE_MULTIPLE_USERS_ERROR:
            return {
                ...state,
                errorActivateMultipleUsers: action.payload,
                loadingActivateMultipleUsers: false
            }
        default:
            return state
    }
}
